/**
 * Standalone-бандл логики для пропатченного `error-counter`.
 * Данный файл импортируется в entry с `error-counter` в webpack-конфиге.
 * Не переиспользовать в общем бандле!
 */

import type {ErrorScope} from './types'
import {
  processMetrikaErrors,
  processMapsErrors,
  processResourceFails,
  processUnhandledRejection,
  processChunkTimeouts,
  processKnownIssues,
} from './processors'
import {updateAdditional} from './utils'

Ya.Rum.updateErrors({
  transform: error => {
    const originalMessage = error.message
    const updateError: ErrorScope['updateError'] = data => {
      const e = Object.assign(error, data)

      if (originalMessage !== e.message) {
        updateAdditional(error, 'msg', originalMessage)
      }

      if (e.service) {
        e.message = `${e.service.toUpperCase()}: ${e.message}`
      }

      return e
    }

    try {
      return [
        processMetrikaErrors,
        processMapsErrors,
        processResourceFails,
        processUnhandledRejection,
        processChunkTimeouts,
        processKnownIssues,
      ].some(f => f(error, {updateError}) === false)
        ? false
        : error
    } catch (o_O) {
      Ya.Rum.logError({message: 'EB transform crash', level: 'critical'}, o_O as Ya.Rum.LoggableError)
      return false
    }
  },
})
